<template>
  <div id="app">
     <!-- 只有当router-view的组件是UserDetail时，才会被keep-alive缓存 -->
     <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 不需要缓存的页面，直接渲染 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* max-width: 480px; */
  margin: 0 auto;
  overflow-y: scroll;
  background: #18171C;
}
</style>
